<template>
    <div class="container">
      <div id="div_banner" class="banner1">
        <img src="../../assets/jiejuefangan.png" alt="解决方案">
        <div>
          <p>解决方案</p>
          <span>Solution</span>
        </div>
<!--        <img v-if="imgUrl"  :src="imgUrl"  alt="解决方案" height="190">-->
      </div>
      <div class="c1">
        <div class="title">
          <h2>解决方案</h2>
          <h3>SOLUTION</h3>
        </div>
        <div id="div_Solution" class="c1_main">
          <div class="solut-t-b s-top">
            <div class="solut-t-b-main">
              <div class="content-title">
                “数字化”改革业务
              </div>
              <div class="content-body">
                以数字化改革引领生活高质量发展
              </div>
            </div>
<!--            <img :src="baseUrl + item.fsolutionUrl"/>-->
          </div>
          <div class="solut-content" v-for="(item,index) in SolutionDate">
            <div class="solut-content-left" v-if="!(index%2) && index <= 4">
              <div class="solut-content-left-main">
                <div class="content-title">
                  {{item.fsolutionName}}
                </div>
                <div class="content-body">
                  {{item.fsolutionSummary}}
                </div>
                <div class="detail">
                  <router-link  :to="{path: '/solutionDetail',query:{id:item.fsolutionId}}">查看详情</router-link>
                </div>
              </div>
              <img :src="baseUrl + item.fsolutionUrl"/>
            </div>
            <div class="solut-content-right" v-else-if="(index%2) && index <= 4">
              <div class="solut-content-right-main">
                <div class="content-title">
                  {{item.fsolutionName}}
                </div>
                <div class="content-body">
                  {{item.fsolutionSummary}}
                </div>
                <div class="detail">
                  <router-link  :to="{path: '/solutionDetail',query:{id:item.fsolutionId}}">查看详情</router-link>
                </div>
              </div>
              <img :src="baseUrl + item.fsolutionUrl"/>
            </div>
          </div>

            <div class="solut-t-b s-btm" >
              <div class="solut-t-b-main">
                <div class="content-title">
                  智慧交通物流业务
                </div>
                <div class="content-body" style="padding-left: 0!important;">
                  为交通物流参与者提供多样性服务
                </div>
              </div>
            </div>
          <div class="solut-content" v-for="(item,index) in SolutionDate">
            <div class="solut-content-left" v-if="!(index%2) && index > 4">
              <div class="solut-content-left-main">
                <div class="content-title">
                  {{item.fsolutionName}}
                </div>
                <div class="content-body">
                  {{item.fsolutionSummary}}
                </div>
                <div class="detail">
                  <router-link  :to="{path: '/solutionDetail',query:{id:item.fsolutionId}}">查看详情</router-link>
                </div>
              </div>
              <img :src="baseUrl + item.fsolutionUrl"/>
            </div>
            <div class="solut-content-right" v-else-if="(index%2) && index > 4">
              <div class="solut-content-right-main">
                <div class="content-title">
                  {{item.fsolutionName}}
                </div>
                <div class="content-body">
                  {{item.fsolutionSummary}}
                </div>
                <div class="detail">
                  <router-link  :to="{path: '/solutionDetail',query:{id:item.fsolutionId}}">查看详情</router-link>
                </div>
              </div>
              <img :src="baseUrl + item.fsolutionUrl"/>
            </div>
          </div>
<!--          <div class="c1_list clearfix "  v-for="(item,index) in SolutionDate" :key="index" v-if="">-->
<!--            <div class="pic_box" v-bind:class="{fl:index%2!==0,fr:index%2===0}">-->
<!--              <img :src="baseUrl + item.fsolutionUrl" >-->
<!--            </div>-->
<!--            <div class="text  clearfix bg" v-bind:class="{fl:index%2!==0,fr:index%2===0}" >-->
<!--              <div class="wrap " v-bind:class="{fl:index%2!==0,fr:index%2===0}">-->
<!--                <div class="top">-->
<!--                  <h2 class="t1">{{item.fsolutionName}}</h2>-->
<!--                </div>-->
<!--                <div class="bom">{{item.fsolutionSummary}}</div>-->
<!--                <div class="detail">-->
<!--                  <router-link  :to="{path: '/solutionDetail',query:{id:item.fsolutionId}}">查看详情</router-link>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
        </div>
      </div>
    </div>
</template>

<script>
  import axios from '../../../static/js/commonAxios'
    export default {
      name: "solution",
      data(){
        return{
          SolutionDate:[],
          baseUrl:'',
          imgUrl:'',//头部图
        }
      },
      mounted(){
        this.baseUrl = process.env.API_ROOT;
        this.getSolutionDate()
        this.getbar()
      },
      methods:{
        getbar(){
          axios.get('/api/bar').then((res) => {
            if(res.data.success){
              let item=res.data.items
              item.forEach(arr=>{
                if(arr.fbar==='解决方案'){
                  this.imgUrl = this.baseUrl + arr.fbarUrl
                }
              })
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
        getSolutionDate(){
          axios.get('/api/solution').then((res) => {
            if(res.data.success){
              this.SolutionDate = []
              this.SolutionDate = res.data.items.filter((item , index)=> {
                if (index !== 0 && index !== 6) {
                  return item
                } else {
                  return  false
                }
              })
              console.log(this.SolutionDate)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
      }
    }
</script>

<style scoped>
  .title{
    text-align: center;
    background: url(../../assets/2.png) no-repeat center 15px;
  }
  .title h2{
    font-size: 30px;
    color: #333333;
  }
  .title h3{
    font-size: 14px;
    color: #666666;
    margin-top: 10px;
  }
  .c1{
    width: 100%;
    position: relative;
    padding-top: 80px;
  }
  .c1 .c1_main{
    /*width: 85%;*/
    width: 1200px;
    padding-top: 60px;
    padding-bottom: 140px;
    margin: auto;
  }
  .c1 .c1_main .solut-content{
    width: 100%;
    /*height: 340px;*/
    margin-top: 30px;
    margin-bottom: 30px;
    background-color: #fff;
  }
  .c1 .c1_main .solut-content .solut-content-left{
    position: relative;
    height: 100%;
    height: 340px;
  }
  .c1 .c1_main .solut-content .solut-content-left .solut-content-left-main{
    max-width: 500px;
    display: inline-block;
    box-sizing: border-box;
    padding: 39px 75px;
  }
  .c1 .c1_main .solut-content .solut-content-left .solut-content-left-main .content-title{
    font-size: 18px;
    font-weight: bold;
    color: #333339;
    line-height: 22px;
  }
  .c1 .c1_main .solut-content .solut-content-left .solut-content-left-main .content-body{
    height: 62px;
    width: 360px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    margin-top: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
  }
  .c1 .c1_main .solut-content .solut-content-left .solut-content-left-main .detail a{
    position: absolute;
    display: inline-block;
    bottom: 34px;
    width: 122px;
    height: 32px;
    border: 1px solid #1782E7;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }
  .c1 .c1_main .solut-content .solut-content-left .solut-content-left-main .detail:hover a{
    background-color: #1782E7;
  }
  .c1 .c1_main .solut-content .solut-content-left .solut-content-left-main .detail:hover a{
    color: #fff!important;
  }
  .c1 .c1_main .solut-content .solut-content-left img{
    width: 680px;
    height: 340px;
    float: right;
  }


  .c1 .c1_main .solut-content .solut-content-right{
    position: relative;
    height: 100%;
    height: 340px;
  }
  .c1 .c1_main .solut-content .solut-content-right .solut-content-right-main{
    float: right;
    max-width: 500px;
    display: inline-block;
    box-sizing: border-box;
    padding: 39px 75px;
  }
  .c1 .c1_main .solut-content .solut-content-right .solut-content-right-main .content-title{
    font-size: 18px;
    font-weight: bold;
    color: #333339;
    line-height: 22px;
  }
  .c1 .c1_main .solut-content .solut-content-right .solut-content-right-main .content-body{
    height: 59px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
    margin-top: 30px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
  }
  .c1 .c1_main .solut-content .solut-content-right .solut-content-right-main .detail{
    position: absolute;
    bottom: 34px;
    width: 122px;
    height: 32px;
    border: 1px solid #1782E7;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    color: #333;
    font-weight: 400;
  }
  .c1 .c1_main .solut-content .solut-content-right .solut-content-right-main .detail:hover{
    background-color: #1782E7;
  }
  .c1 .c1_main .solut-content .solut-content-right .solut-content-right-main .detail:hover a{
    color: #fff!important;
  }
  .c1 .c1_main .solut-content .solut-content-right img{
    width: 680px;
    height: 340px;
    float: left;
  }
  .c1 .c1_main .solut-t-b{
    box-sizing: border-box;
    width: 100%;
    height: 148px;
    padding: 36px 122px;
    /*background-color: #146CE8;*/
  }
  .c1 .c1_main .s-top{
    background: url("../../assets/jjfa1.png");
  }
  .c1 .c1_main .s-btm{
    background: url("../../assets/jjfa2.png");
  }
  .c1 .c1_main .solut-t-b .content-title{
    width: 313px;
    text-align: center;
    font-size: 32px;
    font-weight: 400;
    color: #FFFFFF;
    /*line-height: 72px;*/
  }
  .c1 .c1_main .solut-t-b .content-body{
    box-sizing: border-box;
    width: 313px;
    font-size: 18px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 30px;
    padding-top: 12px;
    padding-left: 20px;
    /*padding: 0px 55px 0 55px;*/
    text-align: center;
  }
  /*.c1 .c1_main .c1_list{*/
  /*  width: 100%;*/
  /*}*/
  /*.c1 .c1_main .c1_list .pic_box{*/
  /*  width: 48%;*/
  /*  height: 450px;*/
  /*  overflow: hidden;*/
  /*}*/
  .c1 .c1_main .c1_list .pic_box img{
    display: block;
    height: 100%;
    width: auto;
  }
  /*.c1 .c1_main .c1_list .bg{*/
  /*  background: url(../../assets/57.png) no-repeat left 415px;*/
  /*}*/

  /*.c1 .c1_main .c1_list .bg1{*/
  /*  background: url(../../assets/58.png) no-repeat left 420px;*/
  /*}*/
  /*.c1 .c1_main .c1_list .text{*/
  /*  width: 48%;*/
  /*  height: 410px;*/
  /*  padding-top: 90px;*/
  /*}*/
  /*.c1 .c1_main .c1_list .text .wrap{*/
  /*  width: 100%;*/
  /*}*/
  /*.c1 .c1_main .c1_list .text .wrap .top{*/
  /*  padding-bottom: 20px;*/
  /*  margin-bottom: 40px;*/
  /*  background: url(../../assets/40.jpg) no-repeat left bottom;*/
  /*}*/
  .c1 .c1_main .c1_list .text .wrap .top h2{
    font-size: 18px;
    font-weight: bold;
    color: #333333;
    padding-left: 40px;
    line-height: 35px;
  }
  /*.c1 .c1_main .c1_list .text .wrap .top .t1{*/
  /*  background: url(../../assets/30.png) no-repeat left center;*/
  /*}*/

  /*.c1 .c1_main .c1_list .text .wrap .top .t2{*/
    /*background: url(../images/31.png) no-repeat left center;*/
  /*}*/

  /*.c1 .c1_main .c1_list .text .wrap .top .t3{*/
    /*background: url(../images/32.png) no-repeat left center;*/
  /*}*/

  /*.c1 .c1_main .c1_list .text .wrap .top .t4{*/
    /*background: url(../images/33.png) no-repeat left center;*/
  /*}*/

  /*.c1 .c1_main .c1_list .text .wrap .top .t5{*/
    /*background: url(../images/34.png) no-repeat left center;*/
  /*}*/
  /*.c1 .c1_main .c1_list .text .wrap .bom{*/
  /*  font-size: 14px;*/
  /*  color: #666;*/
  /*  line-height: 30px;*/
  /*}*/
  .c1 .c1_main .c1_list .text .wrap .detail a{
    display: block;
    width: 120px;
    height: 30px;
    border: 1px solid #8ec31f;
    color: #333;
    font-size: 14px;
    margin-top: 45px;
    text-align: center;
    line-height: 30px;
    border-radius: 5px;
    text-decoration: none;
  }
  .c1 .c1_main .c1_list .text .wrap .detail a:hover{
    background: #8ec31f;
    color: #fff;
  }
  /*.c1 .c1_main .c1_list .text .pdr{*/
  /*  padding-right: 60px;*/
  /*  padding-left: 0;*/
  /*}*/
  @media screen and (max-width: 1024px){
    .c1 {
      width: 100%;
      left: 0;
      margin-left: 0;
    }
    /*.c1 .c1_main .c1_list .pic_box {*/
    /*  width: 50%;*/
    /*}*/
    /*.c1 .c1_main .c1_list .text {*/
    /*  width: 50%;*/
    /*}*/
    /*.c1 .c1_main .c1_list .text .wrap {*/
    /*  width: auto;*/
    /*}*/
  }

</style>



// WEBPACK FOOTER //
// src/components/solution/solution.vue